
<style lang="less">
@import "./AppMain.less";
</style>

<template>
  <div class="app-main-container">
    <div class="bread-crumb-container">
      <Breadcrumb />
    </div>
    <section class="app-main">
      <div class="app-container">
        <transition name="fade-transform" mode="out-in">
          <router-view ref="rv" :key="key" />
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { Notification } from 'element-ui';
export default {
  name: 'AppMain',
  components: {
    Breadcrumb
  },
  data() {
    return {
      key: this.$router.currentRoute.fullPath
    }
  },
  async mounted() {
    setTimeout(async() => {
      const h = this.$createElement
      let messageNum = await this.$store.dispatch('activityApply/refundTip', {})
      if (messageNum&&messageNum>0&&this.$store.state.auth.token) {
        this.$notify.info({
          title: '提示',
          customClass: 'notifyInfo',
          // message: `有${messageNum}单待处理的退款单`,
          message: h('div', null, [
              h('p', null, `有${messageNum}单待处理的退款单`),
              h('div', {
                style: {
                  textAlign: 'right'
                }
              }, [
                h('el-button', {
                  style: {
                  },
                  attrs: {
                    size: 'small',
                    type: 'primary'
                  },
                    on:{
                        click:this.clickBtn
                    }
                }, "退款列表")
              ]),
          ]),
          duration: 0
        })
    }
    }, 1000)
  },
  methods: {
    clickBtn() {
      console.log(this.$route.path);
      if (this.$route.path !== '/order/refund') {
        this.$router.push('order/refund')
      }
      Notification.closeAll()
    }
  }
}
</script>
<style lang='less'>
.notifyInfo {
  .el-notification__group {
    width: 100%;
  }
}
</style>


